const authReferrer = {
  add(link) {
    localStorage.setItem('auth-referrer', link);
  },

  get() {
    return localStorage.getItem('auth-referrer');
  },

  remove() {
    localStorage.removeItem('auth-referrer');
  },
};

export default authReferrer;
